export default __webpack_public_path__ + "static/storage-map-48de78a4f676dd3129102dadd7f90751.svg";